import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers';

const storage = createLocalStorageProvider('jira-platform-service-worker-window');
export const getStorage = () => storage;

export const getCurrentTime = () => new Date().getTime();
